import { ImageFormat } from '../store/entities/types';
export function fetchAssetIdFromSherbertUrl(assetUrl) {
    if (!assetUrl)
        return '';
    return assetUrl.split('/assets/')[1].split('/')[0];
}
// Checks if the file is a Raster Image supported by Sherbert
export function isRaster(file) {
    if (file.type.includes(ImageFormat.bmp) ||
        file.type.includes(ImageFormat.jpeg) ||
        file.type.includes(ImageFormat.png) ||
        file.type.includes(ImageFormat.tga) ||
        file.type.includes(ImageFormat.tiff) ||
        file.type.includes(ImageFormat.webp))
        return true;
    return false;
}
// This function provides ImageFormat of Raster Images supported by Sherbert
export function getImageFormat(type) {
    if (type.includes(ImageFormat.jpeg))
        return ImageFormat.jpeg;
    if (type.includes(ImageFormat.png))
        return ImageFormat.png;
    if (type.includes(ImageFormat.bmp))
        return ImageFormat.bmp;
    if (type.includes(ImageFormat.tga))
        return ImageFormat.tga;
    if (type.includes(ImageFormat.tiff))
        return ImageFormat.tiff;
    if (type.includes(ImageFormat.webp))
        return ImageFormat.webp;
    return ImageFormat.unknown;
}
export var VariantTypes;
(function (VariantTypes) {
    VariantTypes["Original"] = "original";
    VariantTypes["Print"] = "print";
    VariantTypes["WebPreview"] = "webPreview";
    VariantTypes["Thumb"] = "thumb";
    VariantTypes["BackgroundRemoved"] = "backgroundRemoved";
    VariantTypes["Sharpened"] = "sharpened";
    VariantTypes["Embroidery"] = "embroidery";
    VariantTypes["Monochrome"] = "monochrome";
})(VariantTypes || (VariantTypes = {}));
//# sourceMappingURL=utility.js.map